import { Component, ElementRef, OnInit, SimpleChanges } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { NgbOffcanvasConfig, NgbOffcanvas, NgbModal, NgbModalConfig, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { filter } from 'rxjs';
import { InscriptionForm } from '../../../../../core/request-forms/InscriptionForm';
import { AcademicYearService } from '../../../../../core/services/academic-year.service';
import { InscriptionFileService } from '../../../../../core/services/inscription-file.service';
import { InscriptionService } from '../../../../../core/services/inscription.service';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';
import { GlobalName } from '../../../../../core/utils/global-name';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import { IGX_STEPPER_DIRECTIVES } from 'igniteui-angular';
import { IgxStepper,IStepChangingEventArgs } from 'igniteui-angular/lib/stepper/stepper.common';
import { ClassroomService } from '../../../../../core/services/classroom.service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../layout/includes/header/header.component';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
    selector: 'app-inscription',
    templateUrl: './inscription.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule, NgxPaginationModule],
    styleUrls: ['./inscription.component.css']
})
export class InscriptionComponent implements OnInit {
  buttonsPermission :any|undefined;
 search_text=""
 loading=false
  data:any[] =[]
  classrooms:any[] =[]
  selected_data:any;
  is_valid=null
  fileInput:any

  pg={
    pageSize:10,
    p:0,
    total:0
  }
  tag="admin-inscription"
  constructor(
    private classroomService:ClassroomService,
    private ayService:AcademicYearService,
    private insService:InscriptionService,
    private router:Router,
    private activatedRoute:ActivatedRoute,
    private _sanitizationService: DomSanitizer,
    configOffCanvas: NgbOffcanvasConfig,
     private offcanvasService: NgbOffcanvas,
     private toastrService: ToastrService,
     private insFileService:InscriptionFileService,
     private lsService:LocalStorageService,
     config: NgbModalConfig,
    private modalService: NgbModal) {
      config.backdrop = 'static';
      config.keyboard = false;
      
    configOffCanvas.position = 'end';
		configOffCanvas.backdropClass = 'bg-dark';
		configOffCanvas.keyboard = false;
   }
  ngOnInit(): void {
    this.buttonsPermission={
      show:true,
      add:true,
      edit:true,
      delete:true,
      status:true,
    }
   this.getAll()
   this.getClassrooms()
  }

  getClassrooms(){
    this.classroomService.getAll().subscribe((res:any)=>{
      this.classrooms=res.data
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des inscriptions",err)
    })
  }

  getAll(){

    this.insService.getAll().subscribe((res:any)=>{
      this.data=res.data
      this.pg.p=0
      this.pg.total=res.data.length
      },
  (err:any)=>{
    AppErrorShow.showError("Gestion des inscriptions",err)

  })
  }

  checked(el?:any){
    this.selected_data=el;
    this.is_valid=el.is_valid
  }
  verifyIfElementChecked(){
    console.log(this.selected_data)
    if (this.selected_data==null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }
  
    show(){
    if(!this.verifyIfElementChecked()) return ;
    this.router.navigate(['/admin/inscription-details/'+this.selected_data.code])
  }
  openMasse(content:any){
    this.modalService.open(content)
   
  }


  upload(ev:any){
    if (ev?.target.files.length!=0) {
      this.fileInput=ev?.target.files[0]
    }
   }

  storeMasse(value:any){
    let formData=new FormData()
        formData.append('file',this.fileInput)
        formData.append('classroom_id',value.classroom_id)

        this.loading=true
    this.insService.storeMasse(formData).subscribe((res:any)=>{
      this.loading=false
      this.toastrService.success(res.message)
      this.modalService.dismissAll()
      this.router.navigate(['/admin/students']);
  },
  (err:any)=>{
    this.loading=false
    AppErrorShow.showError("Gestion des inscriptions",err)

  })
  }


  delete(){
    if(!this.verifyIfElementChecked()) return ;
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.insService.delete(this.selected_data.id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
      console.log(err)
        AppErrorShow.showError("Gestion des inscriptions",err)

    })
  }
})
  }

  setStatus(value:any){

    this.toastrService.warning("Opération en cours")
  
        this.insService.setState(this.selected_data.code,value).subscribe((res:any)=>{
          this.toastrService.success(res.message)
          this.getAll()
      },
      (err:any)=>{
        console.log(err)
          AppErrorShow.showError("Gestion des inscriptions",err)

      })
  }
 
  getPage(event:any){
    this.pg.p=event
  }

}
